<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onOverlayClick($event)">
    <section
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      cdkTrapFocusAutoCapture
      (click)="$event.stopPropagation()">
      <header class="dialog-header">
        <h2 class="dialog-title" [id]="titleId">
          {{ t('lang.file_required_inputs_title') }}
        </h2>
        <p class="dialog-subtitle" [id]="descriptionId">
          {{
            t(
              'lang.file_required_inputs_progress',
              progressLabelParams
            )
          }}
        </p>
        <button
          class="close-button"
          type="button"
          [disabled]="busy"
          [attr.aria-label]="t('lang.close')"
          (click)="onClose()">
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </header>

      <div class="progress-track" aria-hidden="true">
        <span class="progress-value" [style.width.%]="progressPercent"></span>
      </div>

      <div class="dialog-content">
        <lib-collection-report-file-card
          [fileName]="file.fileName"
          [sizeBytes]="file.sizeBytes"
          action="NONE" />

        @for (requiredInput of file.requiredInputs; track requiredInput.key) {
          @if (statementOriginInput(requiredInput); as originInput) {
            <section class="required-input-section">
              <h3 class="required-input-question">
                {{ t('lang.file_required_inputs_statement_origin_question') }}
              </h3>
              <p class="required-input-helper">
                {{ t('lang.file_required_inputs_statement_origin_helper') }}
              </p>
              <label class="required-input-label">
                {{ t('lang.file_required_inputs_statement_origin_label') }}
              </label>
              <lib-statement-origin-picker
                class="required-input-control"
                [collectionId]="collectionId"
                [revisionId]="revisionId"
                [constraint]="originInput.constraint"
                [selectedId]="selectedStatementOriginId"
                [disabled]="busy"
                [invalid]="!!errorMessage"
                (selectionChange)="resolveStatementOrigin($event)" />
            </section>
          } @else if (isSourceCurrencyInput(requiredInput)) {
            <section class="required-input-section">
              <h3 class="required-input-question">
                {{ t('lang.file_required_inputs_currency_question') }}
              </h3>
              <p class="required-input-helper">
                {{ t('lang.file_required_inputs_currency_helper') }}
              </p>
              <label class="required-input-label">
                {{ t('lang.file_required_inputs_currency_label') }}
              </label>
              <mzic-select-basic
                class="required-input-control"
                [searchable]="true"
                [disabled]="busy"
                [options]="currencyOptions"
                [optionsSelected]="selectedSourceCurrency()"
                [placeholder]="t('lang.file_validation_select_currency')"
                (optionChange)="resolveSourceCurrency($event)" />
            </section>
          } @else {
            <p class="unsupported-required-input" role="alert">
              {{
                t('lang.file_validation_unsupported_input', {
                  key: requiredInput.key,
                })
              }}
            </p>
          }
        }

        @if (errorMessage) {
          <p class="dialog-error" role="alert">{{ errorMessage }}</p>
        }
      </div>

      <footer class="dialog-footer">
        <button
          class="primary-button"
          type="button"
          [disabled]="!canSubmit"
          (click)="onSubmit()">
          @if (busy) {
            <mzic-spinner />
          }
          {{ t('lang.file_required_inputs_save_continue') | uppercase }}
        </button>
        <button
          class="secondary-button"
          type="button"
          [disabled]="busy"
          (click)="onClose()">
          {{ t('lang.cancel') | uppercase }}
        </button>
      </footer>
    </section>
  </div>
</ng-container>
